/** Stub for CDN bundle */
export default function uuid() {
  return '00000000-0000-0000-0000-000000000000';
}
